import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Home::MwHomeStartPage />",{ moduleName: "mewe/templates/start.hbs" })